import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, numberFormat, pieChart, responsivefy} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    console.log("Chart vizName called:", vizName, divId, url)

    // load the data
    axios.post(url, filterParam).then(res => {
        let data = res.data;
        console.log("data is:", data)

        data.forEach(function (d) {
            d.metric1 = +d.metric1;
            return d;
        });
        var width = 600, height = 300;
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId).append('svg')
            .attr('width', width)
            .attr('height', height)
            .call(responsivefy)
            .append('g')
        // .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        var radius = Math.min(width, height) / 2.5;
        console.log("radius", radius)

        var div = d3.select(divId).append("div").attr("class", "toolTip");

        var g = svg.append("g").attr("transform", "translate(" + width / 1.5 + "," + height / 2.5 + ")");

        /* var svg = d3.select("svg"),
             width = chart.width + chart.margin.right - chart.margin.left,
             height = chart.height + chart.margin.top + chart.margin.bottom,
             radius = Math.min(width, height) / 2,
             g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");*/

        // d3.select(divId);

        var color = d3.scaleOrdinal().range(pieChart);


        /* ["#98abc5",
         "#8a89a6",
         "#7b6888",
         "#6b486b",
         "#a05d56",
         "#d0743c",
         "#ff8c00",
         "#e34d01",
         "#ccff05",
         "#3e7eca",
         "#aa0092",
         "#b32e4f"]);*/

        var pie = d3.pie()
            .sort(null)
            .value(function (d) {
                return d.metric1;
            }).sort(null);

        var tots = d3.sum(data, function (d) {
            return d.metric1;
        });

        console.log("tots", tots)

        // data.forEach(function(d) {
        //     d.percentage = d.values  / tots;
        //     d.total=tots
        // });

        console.log("datapie", data)

        var path = d3.arc()
            .outerRadius(radius - 5)
            .innerRadius(40);

        // var outerArc = d3.arc()
        //     .innerRadius(radius * 0.9)
        //     .outerRadius(radius * 0.9);
        //
        // var label = d3.arc()
        //     .outerRadius(radius - 40)
        //     .innerRadius(radius - 40);

        var arc = g.selectAll(".arc")
            .data(pie(data))
            .enter().append("g")
            .attr("class", "arc");


        arc.append("path")
            .attr("d", path)
            .attr("fill", function (d) {
                return color(d.data.dim1_name);
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.data.dim1_name + '<br>' +
                    Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + '(' + numberFormat(d.data.metric1) + ' out of ' + numberFormat(tots) + ')')
                    .style("display", "block")
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition()
                    .style("display", "none")
                    .style("opacity", 0)
            })

        // arc.append('text')
        //     .attr("x", 40)
        //     .attr("y", 70)
        //     .attr("dy", ".35em")
        //     .text(function(d) { return numberFormat(d.data.metric1)})


        arc.append("svg:text")                                     //add a label to each slice
            .attr("transform", function (d) {                    //set the label's origin to the center of the arc
                //we have to make sure to set these before calling arc.centroid
                d.innerRadius = 0;
                d.outerRadius = 40;
                return "translate(" + path.centroid(d) + ")";        //this gives us a pair of coordinates like [50, 50]
            })
            .attr("text-anchor", "middle")                          //center the text on it's origin
            .text(function (d) {
                return numberFormat(d.data.metric1)
            });

        // Now we'll draw our label lines, etc.
//--------------------------------------------

        // arc.append("text")
        //
        //     .attr("transform", function (d, i) {
        //         var pos = outerArc.centroid(d);
        //         pos[0] = radius * (midAngle(d) < Math.PI ? 1.1 : -1.1);
        //
        //         var percent = (d.endAngle - d.startAngle) / (2 * Math.PI) * 100
        //         if (percent > 1) {
        //             //console.log(percent)
        //             pos[1] += i * 15
        //         }
        //         return "translate(" + pos + ")";
        //     })
        //     .text(function (d) {
        //         return d.data.dim1_name;
        //     })
        //     .attr("fill", function (d, i) {
        //         return color(i);
        //     })
        //     .attr("text-anchor", 'left')
        //     .attr("dx", function (d) {
        //         var ac = midAngle(d) < Math.PI ? 0 : -50
        //         return ac
        //     })
        //     .attr("dy", 5)
        //
        //
        // function midAngle(d) {
        //     return d.startAngle + (d.endAngle - d.startAngle) / 2;
        // }
        //
        //  g.selectAll("polyline")
        //     .data(pie(data), function (d) {
        //         return d.data.dim1_name;
        //     })
        //     .enter()
        //     .append("polyline")
        //     .attr("points", function (d, i) {
        //         var pos = outerArc.centroid(d);
        //         pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
        //         var o = outerArc.centroid(d)
        //         var percent = (d.endAngle - d.startAngle) / (2 * Math.PI) * 100
        //         console.log("percent:",percent)
        //         if (percent > 1) {
        //             //console.log(percent)
        //             o[1]
        //             pos[1] += i * 15
        //         }
        //         console.log("pos:", [label.centroid(d),[o[0],0[1]] , pos]);
        //         //return [label.centroid(d),[o[0],0[1]] , pos];
        //         return [label.centroid(d), [o[0], pos[1]], pos];
        //     })
        //     .style("fill", "none")
        //     //.attr('stroke','grey')
        //     .attr("stroke", function (d, i) {
        //         return color(i);
        //     })
        //     .style("stroke-width", "2px");

        var label = svg.append('g')
            .append('text')
            .attr("x", 70)
            .attr("y", 40)
            .text(chart.y1AxisDisplayName + colonAnnotation + numberFormat(tots))

        console.log(label)

        var legend = svg.append('g')
            .attr("class", "legend")
            .selectAll("g")
            .data(pie(data), function (d) {
                return d.data.dim1_name;
            })//setting the data as we know there are only two set of data[programmar/tester] as per the nest function you have written
            .enter().append("g")
            .attr("transform", function (d, i) {
                return "translate(0," + i * 20 + ")";
            });

        legend.append("rect")
            .attr('x', 10)
            .attr('y', 60)
            .attr("width", 18)
            .attr("height", 18)
            .style("fill", function (d) {
                return color(d.data.dim1_name);
            });

        legend.append("text")
            .attr("x", 40)
            .attr("y", 70)
            .attr("dy", ".35em")
            .text(function (d) {
                return Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + ' ' + d.data.dim1_name
            });
    })
}
